// extracted by mini-css-extract-plugin
export default {"app":"layout-module--app--336G5"};